import styled from 'styled-components';

export const Table = styled.table`
  tr td {
    &:first-child {
      padding-right: 1.5rem;
    }
  }
`;
